// Единно семейство икони за долната навигация (line style, един stroke).
// react-native-svg е включен в Expo Go.

import React from 'react';
import Svg, { Path, Rect, Circle, Line } from 'react-native-svg';

type P = { color: string; size?: number };
const base = (size = 24) => ({ width: size, height: size, viewBox: '0 0 24 24' as const });

export const HomeIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M3 10.5 12 3l9 7.5" />
    <Path d="M5 9.5V20h14V9.5" />
  </Svg>
);

export const BuildingIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Rect x={4} y={3} width={16} height={18} rx={1.5} />
    <Line x1={9} y1={8} x2={11} y2={8} /><Line x1={13} y1={8} x2={15} y2={8} />
    <Line x1={9} y1={12} x2={11} y2={12} /><Line x1={13} y1={12} x2={15} y2={12} />
    <Line x1={9} y1={16} x2={11} y2={16} /><Line x1={13} y1={16} x2={15} y2={16} />
  </Svg>
);

export const ChatIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M4 5h16v11H9l-4 4V16H4z" />
  </Svg>
);

export const MoreIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Circle cx={6} cy={12} r={1.4} fill={color} />
    <Circle cx={12} cy={12} r={1.4} fill={color} />
    <Circle cx={18} cy={12} r={1.4} fill={color} />
  </Svg>
);

export const CardIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Rect x={2.5} y={6} width={19} height={12} rx={2} />
    <Line x1={2.5} y1={10} x2={21.5} y2={10} />
  </Svg>
);

export const WrenchIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M14.5 6.5a3.5 3.5 0 0 1-4.6 4.6L5 16l3 3 4.9-4.9a3.5 3.5 0 0 1 4.6-4.6l-2.3 2.3-1.7-1.7z" />
  </Svg>
);

export const CoinsIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M12 3v18M8 7h6a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h7" />
  </Svg>
);

export const UserIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Circle cx={12} cy={8} r={3.5} />
    <Path d="M5 20c1.2-3.6 4-5 7-5s5.8 1.4 7 5" />
  </Svg>
);

export const BellIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
    <Path d="M10.5 20a2 2 0 0 0 3 0" />
  </Svg>
);

export const SearchIcon = ({ color, size }: P) => (
  <Svg {...base(size)} fill="none" stroke={color} strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <Circle cx={11} cy={11} r={6} /><Line x1={20} y1={20} x2={15.5} y2={15.5} />
  </Svg>
);
